import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import AuthedLayout from "layouts/authed/AuthedLayout";
import AuthLayout from "layouts/auth/AuthLayout";

import LogoutRoute from "views/auth/logout/LogoutRoute";
import LoginPage from "views/auth/login/LoginPage";
import HomePage from "views/home/HomePage";
import SubscriptionPage from "views/myAccount/subscription/SubscriptionPage";
import OrderHistoryPage from "views/myAccount/orderHistory/OrderHistoryPage";
import OrderReceiptPage from "views/myAccount/orderReceipt/OrderReceiptPage";
import CreditWalletPage from "views/myAccount/creditWallet/CreditWalletPage";
import PaymentOptionPage from "views/myAccount/paymentOption/PaymentOptionPage";
import AccountVerificationPage from "views/myAccount/verification/VerificationPage";
import HoldingTankPage from "views/myTeam/holdingTank/HoldingTankPage";
import UplinePage from "views/myTeam/upline/UplinePage";
import UnilevelListPage from "views/myTeam/unilevelList/UnilevelListPage";
import PlacementListPage from "views/myTeam/placementList/PlacementListPage";
import UnilevelTreePage from "views/myTeam/unilevelTree/UnilevelTreePage";
import AccountSettingPage from "views/myAccount/accountSetting/AccountSettingPage";
import ContactManagerPage from "views/contactManager/ContactManagerPage";
import MarketingAssetsPage from "views/tool/marketingAsset/MarketingAssetPage";
import LeaderboardPage from "views/leaderboard/LeaderboardPage";
import EarningPage from "views/earning/EarningPage";
import ReplicatedPage from "views/myWebsite/replicated/ReplicatedPage";
import ShareCartPage from "views/myWebsite/shareCart/ShareCartPage";
import NotificationPage from "views/notification/NotificationPage";
import CheckoutPage from "views/checkout/CheckoutPage";
import SupportPage from "views/support/SupportPage";
import DeclineReportPage from "views/report/declineReport/DeclineReportPage";
import TopEarnerPage from "views/report/topEarner/TopEarnerPage";
import RankReportPage from "views/report/rankReport/RankReportPage";
import NewRankUpPage from "views/report/newRankUp/NewRankUpPage";
import NewBuilderRankUpPage from "views/report/newBuilderRankUp/NewRankUpPage";
import AbandonCartPage from "views/report/abandonCart/AbandonCartPage";
import CustomerReportPage from "views/report/customerReport/CustomerReportPage";
import AffiliateReportPage from "views/report/affiliateReport/AffiliateReportPage";
import RefundedReportPage from "views/report/refundedReport/Page";
import IdAndCreditVerificationPage from "views/idAndCreditVerification/IdAndCreditVerificationPage";
import TaxVerificationPage from "views/taxVerification/TaxVerificationPage";
import ComingSoonPage from "views/comingSoon";
import SubscriptionReportPage from "views/report/subscriptionReport/SubscriptionReportPage";
import PromoterRankTracker from "views/myRank/PromoterRankTracker/PromoterRankTracker";
import BuilderRankTracker from "views/myRank/BuilderRankTracker/BuilderRankTracker";
import UpgradeAccountPage from "views/upgrade/UpgradeAccountPage";
import NVTravelLeaderboardPage from "views/travel/leaderboard/NVTravelLeaderboardPage";
import CustomerPodReportPage from "views/report/customerPodReport/CustomerPodReportPage";
import CustomerLeaderboardPage from "views/report/customerLeaderboard/CustomerLeaderboardPage";
import PlacementTreePage from "views/myTeam/placementTree/PlacementTreePage";
import ActiveCustomerLeaderboardPage from "views/report/activeCustomerLeaderboard/ActiveCustomerLeaderboardPage";
import CustomerReferalLeaderboardPage from "views/report/customerReferalLeaderboard/CustomerReferalLeaderboardPage";
import MyTicketPage from "views/events/myTicket/MyTicketPage";
import LoyaltyWalletPage from "views/myAccount/loyaltyWallet/LoyaltyWalletPage";
import TicketReportPage from "views/report/ticketReport/TicketReportPage";
import GWReportPage from "views/report/gwReport/GWReportPage";
import NuevaWebsitePage from "views/myWebsite/nuevaWebsite/NuevaWebsitePage";
import CurrentPromoterRankReportPage from "views/report/currentRankReport/CurrentPromoterRankReportPage";
import CurrentBuilderRankReportPage from "views/report/currentRankReport/CurrentBuilderRankReportPage";
import ElevateCustomerLeaderboardPage from "views/report/elevateCustomerLeaderboard/ElevateCustomerLeaderboardPage";
import ElevateSMLeaderboardPage from "views/report/elevateSMLeaderboard/ElevateSMLeaderboardPage";

const Routes = () => {
  return (
    <BrowserRouter> 
      <Switch>
        <AuthRoute path="/login" component={LoginPage} />
        <Route path="/logout" component={LogoutRoute} />
        <AuthedRoute path="/" component={HomePage} fullLayout exact={true} />
        <AuthedRoute
          publicRoute={false}
          path="/my_account/subscription"
          component={SubscriptionPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_account/order_history"
          component={OrderHistoryPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_account/setting"
          component={AccountSettingPage}
          fullLayout
        />
        <Route
          path="/my_account/order_receipt/:orderId"
          component={OrderReceiptPage}
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_account/credit_wallet"
          component={CreditWalletPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_account/loyalty_wallet"
          component={LoyaltyWalletPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_account/payment_option"
          component={PaymentOptionPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_account/verification"
          component={AccountVerificationPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_team/holding_tank"
          component={HoldingTankPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_team/upline"
          component={UplinePage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_team/unilevel_list"
          component={UnilevelListPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_team/unilevel_tree"
          component={UnilevelTreePage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_team/placement_list"
          component={PlacementListPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_team/placement_tree"
          component={PlacementTreePage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/contact_manager"
          component={ContactManagerPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/tool/resources"
          component={MarketingAssetsPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/leaderboard"
          component={LeaderboardPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/earning"
          component={EarningPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_website/custom_website"
          component={NuevaWebsitePage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_website/replicated"
          component={ReplicatedPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/my_website/share_cart"
          component={ShareCartPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/notification"
          component={NotificationPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/support"
          component={SupportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/checkout"
          component={CheckoutPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/rank_tracker"
          component={PromoterRankTracker}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/builder_rank_tracker"
          component={BuilderRankTracker}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/rank_history"
          component={RankReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/current_promoter_rank"
          component={CurrentPromoterRankReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/current_builder_rank"
          component={CurrentBuilderRankReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/subscription_report"
          component={SubscriptionReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/leaderboard"
          component={LeaderboardPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/new_promoter_rank_up"
          component={NewRankUpPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/new_builder_rank_up"
          component={NewBuilderRankUpPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/abandon_cart"
          component={AbandonCartPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/customer_report"
          component={CustomerReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/affiliate_report"
          component={AffiliateReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/refunded_report"
          component={RefundedReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/customer_pod"
          component={CustomerPodReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/customer_leaderboard"
          component={CustomerLeaderboardPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/active_customer_leaderboard"
          component={ActiveCustomerLeaderboardPage}
          fullLayout
        />
         <AuthedRoute
          publicRoute={false}
          path="/report/customer_referal_leaderboard"
          component={CustomerReferalLeaderboardPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/verification"
          component={IdAndCreditVerificationPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/tax_form"
          component={TaxVerificationPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/upgrade_account"
          component={UpgradeAccountPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/comingsoon"
          component={ComingSoonPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/travel/nv_travel_leaderboard"
          component={NVTravelLeaderboardPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/ticket/my_ticket"
          component={MyTicketPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/ticket_report"
          component={TicketReportPage}
          fullLayout
        />
         <AuthedRoute
          publicRoute={false}
          path="/report/gw_report"
          component={GWReportPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/elevate_customer_leaderboard"
          component={ElevateCustomerLeaderboardPage}
          fullLayout
        />
        <AuthedRoute
          publicRoute={false}
          path="/report/elevate_sm_leaderboard"
          component={ElevateSMLeaderboardPage}
          fullLayout
        />
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;

const AuthRoute = ({ component: Component, ...props }) => {
  return (
    <Route
      {...props}
      render={(props) => (
        <AuthLayout pathname={props.location.pathname}>
          <Component {...props} />
        </AuthLayout>
      )}
    />
  );
};

const AuthedRoute = ({
  component: Component,
  fullLayout,
  publicRoute,
  ...props
}) => {
  return (
    <Route
      {...props}
      render={(props) => (
        <AuthedLayout
          fullLayout={fullLayout}
          pathname={props.location.pathname}
          publicRoute={publicRoute}
        >
          <Component {...props} />
        </AuthedLayout>
      )}
    />
  );
};
